module.exports = __webpack_public_path__ + "6c4a0dbc/img/cadBim.e369a02a.png";